if (!customElements.get('hatitude-live-search')) {
  customElements.define('hatitude-live-search', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.details = this.querySelector('details');
      this.toggle = this.querySelector('summary');
      this.input = this.querySelector('input[type="search"]');
      this.results = this.querySelector('.hs-results');
      this.status = this.querySelector('.hs-status');
      this.discover = this.querySelector('.hs-discover');
      this.cache = new Map();
      this.version = 0;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.querySelector('.hs-close').addEventListener('click', () => this.close(), {signal});
      this.details.addEventListener('toggle', () => {
        this.toggle.setAttribute('aria-expanded', String(this.details.open));
        if (this.details.open) {
          document.querySelector('.rv-mega')?.removeAttribute('open');
          this.input.focus({preventScroll:true});
          const query = this.input.value.trim();
          if (query && !this.results.children.length) this.search(query, this.version);
        } else this.cancel();
      }, {signal});
      this.toggle.setAttribute('aria-expanded', 'false');
      this.input.addEventListener('input', () => {
        this.cancel();
        const query = this.input.value.trim();
        this.results.replaceChildren();
        this.discover.hidden = !!query;
        this.status.textContent = query ? this.dataset.loading : '';
        if (!query) return;
        this.timer = setTimeout(() => this.search(query, this.version), 180);
      }, {signal});
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.details.open) {
          event.preventDefault();
          this.close();
        }
        if (!['ArrowDown', 'ArrowUp'].includes(event.key)) return;
        const links = [...this.results.querySelectorAll('[data-hs-result]')];
        if (!links.length) return;
        const index = links.indexOf(document.activeElement);
        if (document.activeElement !== this.input && index < 0) return;
        event.preventDefault();
        const next = index < 0 ? (event.key === 'ArrowDown' ? 0 : links.length - 1) : index + (event.key === 'ArrowDown' ? 1 : -1);
        if (next < 0 || next >= links.length) this.input.focus();
        else links[next].focus();
      }, {signal});
      document.addEventListener('click', event => {
        if (this.details.open && !this.contains(event.target)) this.details.open = false;
      }, {signal});
      this.querySelector('form').addEventListener('submit', event => {
        if (!this.input.value.trim()) { event.preventDefault(); this.input.focus(); }
      }, {signal});
    }
    disconnectedCallback() { this.cancel(); this.controller?.abort(); this.ready = false; }
    cancel() {
      clearTimeout(this.timer);
      this.request?.abort();
      this.version++;
      this.results?.removeAttribute('aria-busy');
    }
    close() { this.details.open = false; this.cancel(); this.toggle.focus(); }
    async search(query, version) {
      this.results.setAttribute('aria-busy', 'true');
      try {
        let html = this.cache.get(query.toLocaleLowerCase());
        if (!html) {
          this.request = new AbortController();
          const url = new URL(this.dataset.endpoint, location.origin);
          url.search = new URLSearchParams({
            q:query, 'resources[type]':'product', 'resources[limit]':'10',
            'resources[options][unavailable_products]':'last',
            'resources[options][fields]':'title,product_type,variants.title',
            section_id:'hatitude-predictive-search'
          }).toString();
          const response = await fetch(url, {signal:this.request.signal,headers:{Accept:'text/html'}});
          if (!response.ok) throw new Error('Search unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const content = doc.querySelector('[data-hatitude-search-response]');
          if (!content) throw new Error('Missing results');
          html = content.outerHTML;
          if (this.cache.size >= 20) this.cache.delete(this.cache.keys().next().value);
          this.cache.set(query.toLocaleLowerCase(), html);
        }
        if (version !== this.version || this.input.value.trim() !== query || !this.details.open) return;
        this.results.innerHTML = html;
        const count = this.results.querySelector('[data-count]').dataset.count;
        this.discover.hidden = Number(count) > 0;
        this.status.textContent = this.dataset.countLabel.replace('[count]', count);
      } catch (error) {
        if (error.name === 'AbortError' || version !== this.version) return;
        this.status.textContent = this.dataset.error;
        this.discover.hidden = false;
      } finally {
        if (version === this.version) this.results.removeAttribute('aria-busy');
      }
    }
  });
}

